import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

export default class extends BridgeComponent {
  static component = 'toast'
  static values = { message: String, type: String, linkLabel: String, linkUrl: String }

  connect() {
    super.connect()
    if (!this.messageValue) return
    this.send('show', {
      message: this.messageValue,
      type: this.typeValue,
      linkLabel: this.linkLabelValue,
      linkUrl: this.linkUrlValue && new URL(this.linkUrlValue, window.location.href).href,
    })
  }
}
